import { CourseSection } from "../../../Utilities";

export function getColor(instance: {
	course: { academicSubject: Pick<CourseSection["course"]["academicSubject"], "color"> };
}) {
	return instance.course.academicSubject.color;
}
